require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./addons-addon-gallery.json") })
        }
      }, "path---addons-addon-gallery");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---addons-addon-gallery!./.cache/json/addons-addon-gallery.json
// module id = 393
// module chunks = 231608221292675